import { render, staticRenderFns } from "./ViewReclamationInvoices.vue?vue&type=template&id=03efb62a&scoped=true&"
import script from "./ViewReclamationInvoices.vue?vue&type=script&lang=js&"
export * from "./ViewReclamationInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03efb62a",
  null
  
)

export default component.exports